import { render, staticRenderFns } from "./static-img.vue?vue&type=template&id=44a58181&scoped=true"
import script from "./static-img.vue?vue&type=script&lang=ts"
export * from "./static-img.vue?vue&type=script&lang=ts"
import style0 from "./static-img.vue?vue&type=style&index=0&id=44a58181&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a58181",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonCustomImage: require('/home/runner/work/ballparkfantasia.com-web/ballparkfantasia.com-web/frontend/components/common/custom-image.vue').default})
